var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
export var TourContext = React.createContext({
    forceRun: function () { return null; },
});
export var TourInnerContext = React.createContext({
    subscribe: function () { return null; },
    unsubscribe: function () { return null; },
    onShown: function () { return new Promise(function () { return null; }); },
    onOpen: function () { return null; },
});
var TourProvider = /** @class */ (function (_super) {
    __extends(TourProvider, _super);
    function TourProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.queue = [];
        _this.listeners = {};
        _this.subscribe = function (id, callbacks, excludeFromQueue) {
            _this.listeners[id] = callbacks;
            if (!excludeFromQueue) {
                _this.pushToQueue(id);
            }
        };
        _this.unsubscribe = function (id) {
            _this.removeFromQueue(id);
        };
        _this.onShown = function (id) { return Promise.resolve(id).then(_this.props.onTourShown); };
        _this.onOpen = function (id) { var _a, _b; return (_b = (_a = _this.props).onOpenTour) === null || _b === void 0 ? void 0 : _b.call(_a, id); };
        _this.isPredicate = function (id) {
            var predicate = _this.props.predicate;
            return predicate ? predicate(id) : true;
        };
        _this.forceRun = function (id) {
            if (_this.currentId) {
                _this.queue = __spreadArray([_this.currentId], _this.queue, true);
                _this.closeTour(_this.currentId);
            }
            _this.currentId = id;
            _this.queue = _this.queue.filter(function (queuedTourId) { return queuedTourId !== id; });
            _this.openTour(id);
        };
        return _this;
    }
    TourProvider.prototype.render = function () {
        return (React.createElement(TourContext.Provider, { value: { forceRun: this.forceRun } },
            React.createElement(TourInnerContext.Provider, { value: {
                    subscribe: this.subscribe,
                    unsubscribe: this.unsubscribe,
                    onShown: this.onShown,
                    onOpen: this.onOpen,
                } }, React.Children.only(this.props.children))));
    };
    TourProvider.prototype.openTour = function (id) {
        var _a;
        (_a = this.listeners[id]) === null || _a === void 0 ? void 0 : _a.run();
    };
    TourProvider.prototype.closeTour = function (id) {
        var _a;
        (_a = this.listeners[id]) === null || _a === void 0 ? void 0 : _a.hide();
    };
    TourProvider.prototype.removeFromQueue = function (id) {
        var _this = this;
        if (id !== this.currentId) {
            return;
        }
        this.currentId = this.queue.find(this.isPredicate);
        this.queue = this.queue.filter(function (id) { return id !== _this.currentId; });
        if (this.currentId) {
            this.openTour(this.currentId);
        }
    };
    TourProvider.prototype.pushToQueue = function (id) {
        this.queue = this.currentId ? this.queue.concat(id) : this.queue;
        if (!this.currentId && this.isPredicate(id)) {
            this.currentId = id;
            this.openTour(id);
        }
    };
    return TourProvider;
}(React.Component));
export { TourProvider };
